import { render, staticRenderFns } from "./PhotographyLifecycleDisplayWidget.vue?vue&type=template&id=3dd2e864&scoped=true"
import script from "./PhotographyLifecycleDisplayWidget.vue?vue&type=script&lang=js"
export * from "./PhotographyLifecycleDisplayWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd2e864",
  null
  
)

export default component.exports